import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'className',
  pure: true // This makes the pipe pure
})
export class RegistryClassNamePipe implements PipeTransform {

  transform(registryItem: any): string {
    if (!registryItem || !registryItem.url || !registryItem.name) {
      return '';
    }

    const url = registryItem.url.toLowerCase();
    const name = registryItem.name.toLowerCase();

    if (url.includes('target') || name.includes('target')) {
      return 'target';
    }

    if (url.includes('amazon') || name.includes('amazon')) {
      return 'amazon';
    }
    if (url.includes('crateandbarrel') || name.includes('crateandbarrel') ||
        (name.includes('crate') && name.includes('barrel'))) {
      return 'crateandbarrel';
    }

    //else return a version of the domain name without any spcial chars or spaces or . 
    if (url) {
      const domainMatch = url.match(/:\/\/(www\.)?(.[^/]+)/);
      if (domainMatch && domainMatch[2]) {
        const domain = domainMatch[2];
        const domainParts = domain.split('.');
        if (domainParts.length >= 2) {
          const mainDomain = domainParts.slice(-2, -1)[0];
          return mainDomain.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
        }
      }
    } else if(name){
    return name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    }

    return '';
  }
}


// WEBPACK FOOTER //
// ./src/app/website/registry-class.pipe.ts